export default __webpack_public_path__ + "static/media/school-bus-management.c4386d22.jpg";